$(document).ready(function() {
    var carousels = $("body:not(.website-state-edit) .carousel");
    carousels.each((i, carousel) => {
        var carouselItems = $(".carousel-item", carousel).length;
        var carouselId = $(carousel).attr("id");
        var indicatiorContainer = $("<ol class='carousel-indicators'></div>");
        for (var i = 0; i < carouselItems; i++) {
            if (i === 0) {
                indicatiorContainer.append(
                    '<li data-target="#' +
                        carouselId +
                        '" data-slide-to="0" class="active"></li>'
                );
            } else {
                indicatiorContainer.append(
                    '<li data-target="#' +
                        carouselId +
                        '" data-slide-to="' +
                        i +
                        '"></li>'
                );
            }
        }
        $(carousel).prepend(indicatiorContainer);
    });
});
window.OwlEnableNav = true;
window.OwlAutoPlay = false;
window.OwlDotsEach = true;
